import { Chip } from '@dxb-web-ui-framework/design-system';
import React, { FC } from 'react';
import { TFunction, useTranslation } from 'react-i18next';
import { TransactionStatus } from '../../../../transaction/src/domain/Transaction/entities/TransactionStatus';
import { useTransactionStatuses } from '../../../../transaction/src/contexts/Parameters/hooks';
export interface PayrollStatusChipProps {
  statusSerialNumber: number;
}
export const getPayrollStatus: (
  statusSerialNumber: number,
  statuses: TransactionStatus[],
  t: TFunction,
) => {
  value: string;
  color: 'default' | 'success' | 'info' | 'error' | 'warning';
} = (statusSerialNumber, statuses, t) => {
  const statusDescriptionFound = statuses.find(st => st.id === statusSerialNumber)?.description;
  switch (statusSerialNumber) {
    case 1:
    case 11:
    case 16:
    case 12:
    case 13:
      return { value: statusDescriptionFound as string, color: 'warning' };
    case 3:
    case 9:
    case 10:
    case 14:
    case 15:
      return { value: statusDescriptionFound as string, color: 'error' };
    case 5:
      return { value: statusDescriptionFound as string, color: 'success' };
    case 0:
    case 2:
    case 4:
    case 6:
    case 7:
    case 8:
      return { value: statusDescriptionFound as string, color: 'info' };
    default:
      return {
        value: statusDescriptionFound ?? t('orderStatus.0'),
        color: 'default',
      };
  }
};
const PayrollStatusChip: FC<PayrollStatusChipProps> = ({ statusSerialNumber }) => {
  const statuses = useTransactionStatuses();
  const { t } = useTranslation();
  return (
    <Chip
      label={getPayrollStatus(statusSerialNumber, statuses, t).value}
      bgColor={getPayrollStatus(statusSerialNumber, statuses, t).color}
    />
  );
};
export { PayrollStatusChip };
